"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactiveFilterListProps = void 0;
const react_1 = __importDefault(require("react"));
const useReactiveFilterSharedProps_1 = require("./useReactiveFilterSharedProps");
/**
 * For use with @appbaseio/reactivesearch SingleList and MultiList components
 */
const useReactiveFilterListProps = (filter) => {
    const reactiveFilterSharedProps = (0, useReactiveFilterSharedProps_1.useReactiveFilterSharedProps)(filter);
    const reactiveFilterListProps = react_1.default.useMemo(() => {
        var _a, _b, _c, _d;
        return (Object.assign(Object.assign({}, reactiveFilterSharedProps), { size: parseInt(filter.displaySize) || undefined, queryFormat: (_a = filter.settingsFilterLogic) !== null && _a !== void 0 ? _a : "or", showFilter: (_b = filter.settingsShowFilter) !== null && _b !== void 0 ? _b : true, showLoadMore: (_c = filter.settingsShowMore) !== null && _c !== void 0 ? _c : false, showSearch: (_d = filter.settingsShowSearch) !== null && _d !== void 0 ? _d : false, showRadio: false, showCheckbox: false }));
    }, [filter, reactiveFilterSharedProps]);
    return reactiveFilterListProps;
};
exports.useReactiveFilterListProps = useReactiveFilterListProps;
//# sourceMappingURL=useReactiveFilterListProps.js.map